import {
  FETCH_SEARCH_RESULTS_BEGIN,
  FETCH_SEARCH_RESULTS_SUCCESS,
  FETCH_SEARCH_RESULTS_FAILURE,
} from "../actions/searchActions";

const initialState = {
  results: [],
  total: 0,
};

export default function searchResultsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SEARCH_RESULTS_BEGIN:
      return {
        ...state,
        loading: true,
        request: action.payload,
      };
    case FETCH_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload.searchResultsResponse.products,
        total: action.payload.searchResultsResponse.products.length,
      };
    case FETCH_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.errors,
      };
    default:
      return state;
  }
}
